"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowValidateDialog = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const lab_1 = require("@material-ui/lab");
const StyledAlert = (0, styled_components_1.default)(lab_1.Alert) `
  padding: 0px;
  background: none;
  .MuiAlert-icon {
    padding-bottom: 0px;
  }
`;
const StyledDialogTitle = (0, styled_components_1.default)(core_1.DialogTitle) `
  display: flex;
  align-items: center;
`;
const StyledDialogContent = (0, styled_components_1.default)(core_1.DialogContent) `
  .MuiSvgIcon-root {
    font-size: 18px;
    &.success {
      color: ${props => props.theme.palette.success.main};
    }
    &.info {
      color: ${props => props.theme.palette.info.main};
    }
    &.error {
      color: ${props => props.theme.palette.error.main};
    }
    &.warning {
      color: ${props => props.theme.palette.warning.main};
    }
  }
  .result-item {
    display: flex;
    .icon {
      margin-right: 6px;
    }
  }
  code {
    font-size: 11px;
    word-break: break-all;
  }
  .item {
    &:not(:last-child) {
      margin-bottom: 8px;
    }
    .label {
      margin-bottom: 4px;
      .title {
        font-weight: 500;
      }
      .MuiTypography-root {
        display: inline-block;
      }
    }
  }
  .state-icon {
    display: flex;
    align-items: center;
    margin-bottom: 1px;
  }
  .state-content {
    margin-left: 24px;
  }
  .plugin-result {
    margin-left: 12px;
    &:not(:last-child) {
      margin-bottom: 4px;
    }
    .icon {
      margin-top: 1px;
    }
  }
`;
const WorkflowValidateDialog = props => {
    const { open, title, children, validator, confirmLabel = 'Confirm', disableWhenValidating, onCancel, onConfirm } = props;
    const [viewAll, setViewAll] = (0, react_1.useState)(false);
    const { result, isValidating = false } = props.result || {};
    const states = (0, react_1.useMemo)(() => {
        return result ? validator.groupByState(result, viewAll) : [];
    }, [result, validator, viewAll]);
    (0, react_1.useEffect)(() => {
        open && setViewAll(false);
    }, [open]);
    const icon = {
        info: react_1.default.createElement(icons_1.CheckCircleOutline, { className: 'info' }),
        success: react_1.default.createElement(icons_1.CheckCircleOutline, { className: 'success' }),
        warning: react_1.default.createElement(icons_1.OfflinePinOutlined, { className: 'warning' }),
        error: react_1.default.createElement(icons_1.HighlightOff, { className: 'error' })
    };
    return (react_1.default.createElement(core_1.Dialog, { fullWidth: true, open: open, onClose: () => {
            if (!isValidating) {
                onCancel === null || onCancel === void 0 ? void 0 : onCancel();
            }
        } },
        isValidating && react_1.default.createElement(core_1.LinearProgress, null),
        react_1.default.createElement(StyledDialogTitle, { disableTypography: true },
            react_1.default.createElement(core_1.Typography, { variant: 'h6' }, title),
            react_1.default.createElement("div", { style: { flex: 1 } }),
            react_1.default.createElement(core_1.Button, { size: 'small', color: 'primary', variant: 'outlined', disabled: isValidating, startIcon: viewAll ? (react_1.default.createElement(icons_1.VisibilityOff, { fontSize: 'small' })) : (react_1.default.createElement(icons_1.Visibility, { fontSize: 'small' })), onClick: () => setViewAll(value => !value) }, viewAll ? 'Filter' : 'Show All')),
        react_1.default.createElement(StyledDialogContent, null,
            children,
            states.length === 0 && !isValidating && (react_1.default.createElement(lab_1.Alert, { severity: 'success' }, "No issues found.")),
            states.length === 0 && isValidating && (react_1.default.createElement(core_1.Typography, { variant: 'body1', color: 'textSecondary' }, "Running Workflow configuration checks...")),
            states.map((state, stateIndex) => {
                const stateKey = `${state.stateNode.name}-${stateIndex}`;
                return (react_1.default.createElement("div", { key: stateKey, className: 'item' },
                    react_1.default.createElement("div", { className: 'result-item label' },
                        react_1.default.createElement("span", { className: 'icon state-icon' }, !state.isValid
                            ? icon.error
                            : state.hasWarning
                                ? icon.warning
                                : icon.success),
                        react_1.default.createElement(core_1.Typography, { variant: 'body1', className: 'title' }, state.stateNode.name)),
                    react_1.default.createElement("div", { className: 'state-content' }, state.plugins.map((plugin, pluginIndex) => {
                        const pluginKey = `${stateKey}-${plugin.path}-${pluginIndex}`;
                        return !plugin.type ? null : (react_1.default.createElement("div", { key: pluginKey, className: 'item' },
                            react_1.default.createElement("div", { className: 'label' },
                                react_1.default.createElement(core_1.Typography, { variant: 'body2', className: 'title' }, plugin.type === 'service'
                                    ? plugin.plugin.name
                                    : plugin.type === 'transition-condition'
                                        ? plugin.plugin.label
                                        : 'Unknown'),
                                ' ',
                                plugin.type !== 'no-plugin' && (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement(core_1.Typography, { variant: 'body2' },
                                        "(",
                                        plugin.type === 'service'
                                            ? 'action'
                                            : 'transition',
                                        ")"),
                                    ' ')),
                                react_1.default.createElement(core_1.Typography, { variant: 'body2', color: 'textSecondary' },
                                    "(",
                                    react_1.default.createElement("code", null, plugin.path),
                                    ")")),
                            plugin.results.map((result, resultIndex) => (react_1.default.createElement("div", { className: 'result-item plugin-result', key: `${pluginKey}-${resultIndex}` },
                                react_1.default.createElement("span", { className: 'icon' }, icon[result.severity]),
                                react_1.default.createElement(core_1.Typography, { variant: 'body2' }, result.message))))));
                    }))));
            })),
        react_1.default.createElement(core_1.DialogActions, null,
            result && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(StyledAlert, { severity: result.isValid ? 'success' : 'error' }, !result.isValid
                    ? 'Failed'
                    : result.hasWarning
                        ? 'Passed (warnings)'
                        : 'Passed'),
                react_1.default.createElement("div", { style: { flex: 1 } }))),
            react_1.default.createElement(core_1.Button, { disabled: isValidating, onClick: onCancel }, "Dismiss"),
            react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'contained', disabled: disableWhenValidating && isValidating, onClick: onConfirm }, confirmLabel))));
};
exports.WorkflowValidateDialog = WorkflowValidateDialog;
exports.default = exports.WorkflowValidateDialog;
//# sourceMappingURL=WorkflowValidateDialog.js.map